import CollectionShelfv2 from 'src/components/restructure/product/shelves/CollectionShelfV2'

export default function ProductCarrosel({
  carrossel,
  carroselConfig,
  enable,
}: any) {
  return (
    <>
      {carrossel.map((collection: any) => {
        return (
          <CollectionShelfv2
            key={collection.collectionId}
            collections={[
              {
                id: collection.collectionId,
                engine: 'vtex',
                text: '',
              },
            ]}
            enableSession={enable}
            title={carroselConfig.title}
          />
        )
      })}
    </>
  )
}
